import React, { FC } from 'react'

import { GenericAttributeRendererProps, GenericTextAttributeRenderer } from '@Components/Product/GenericTextAttributeRenderer'

type MaterialsProps = Pick<GenericAttributeRendererProps, 'asSection' | 'includeHeader' | 'product' | 'selectedVariantID'>

export const ProductMaterials: FC<MaterialsProps> = props => (
  <GenericTextAttributeRenderer {...props} attributeKeyName="materialsText" header="products:PP_MATERIAL_TITLE" />
)
